
import HModal from '@/components/modal/index.vue'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'LogoffModal',
  components: {
    HModal
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String as PropType<'success' | 'warn'>,
      default: 'warn'
    }
  },
  setup(props, { emit }) {
    function close() {
      emit('close', false)
      window.close()
    }

    function handleVerify() {
      window.close()
    }

    return {
      props,
      close,
      handleVerify
    }
  }
})
